import { Route, Switch } from 'react-router-dom';
import SendFlow from '@/pages/send-flow';
import AbResults from '@/pages/ab-results';
import Dashboard from '@/pages/dashboard';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={SendFlow} />
      <Route exact path="/ab-results" component={AbResults} />
      <Route exact path="/dashboard" component={Dashboard} />
    </Switch>
  );
}
